import usePrivateAxios from '@/common/api/usePrivateAxios'
import { useMutation } from '@tanstack/react-query'

type DeleteCompanySpecialEntryProps = {
  companyId?: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

export const useDeleteCompanySpecialEntry = ({ companyId, onSuccess, onError }: DeleteCompanySpecialEntryProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deleteCompanySpecialEntry', companyId],
    mutationFn: async (specialEntryId: string) => {
      const fee_rule_attributes = {
        special_entries_attributes: [
          {
            id: specialEntryId,
            _destroy: true,
          },
        ],
      }

      return privateAxios.put(`/client/companies/${companyId}/fee_rule`, {
        fee_rule_attributes,
      })
    },
    onSuccess,
    onError,
  })
}
